import BalanceContainer from './balance_container';

export default BalanceContainer;
